import React, { useState, useEffect } from "react";
import { makeStyles, Container } from "@material-ui/core";
import Page from "src/components/Page";
import actions from "src/duck/global/actions";
import { connect } from "react-redux";
import KmFilteredTable from "src/components/common/KmFilteredTable";
import { apiEndpoints, apiGetByIdRequest } from "src/utils/api/api";
import { addCreatedUpdatedPublishedArchivedFields } from "src/utils/utils";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import { NavLink as RouterLink } from "react-router-dom";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import { useNavigate } from "react-router-dom";
import SearchIcon from "@material-ui/icons/Search";

const useStyles = makeStyles((theme) => ({
  root: {
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  massagebox: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
}));

const RowButtons = (row) => {
  return (
    <Tooltip title="Podgląd">
      <IconButton
        aria-label="podgląd"
        component={RouterLink}
        to={`/aktualnosci/podglad/${row.id}`}
      >
        <SearchIcon />
      </IconButton>
    </Tooltip>
  );
};

const ArchivedView = ({ enableGlobalLoader, disableGlobalLoader, setLogoutUser }) => {
  const classes = useStyles();

  const [rows, setRows] = useState([]);
  const [reloadCounter, setReloadCounter] = useState(0);
  const [selectedRowIds, setSelectedRowIds] = useState([]);
  const [dialogOpen, setOpen] = useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();

  useEffect(() => {
    enableGlobalLoader();
    apiGetByIdRequest(apiEndpoints.getNewsByStatusKey.path, "archived", true)
      .then((data) => {
        disableGlobalLoader();
        setRows(
          addCreatedUpdatedPublishedArchivedFields(
            data,
            "createdBy",
            "createdAt",
            "updatedBy",
            "updatedAt",
            "publishedBy",
            "publishedAt",
            "archivedBy",
            "archivedAt",
            ", "
          )
        );
      })
      .catch((error) => {
        disableGlobalLoader();
        if (error.response && error.response.status === 401) {
          setLogoutUser();
        }
      });
    return () => {};
  }, [reloadCounter]);

  const headCells = [
    {
      id: "title",
      numeric: false,
      disablePadding: true,
      fieldName: "title",
      sortable: true,
      main: true,
      label: "Tytuł",
    },
    {
      id: "created",
      fieldName: "createdAt",
      fieldName2: "createdBy",
      kmUdField: true,
      numeric: false,
      disablePadding: false,
      sortable: true,
      searchable: true,
      label: "Kiedy i kto utworzył",
    },
    {
      id: "updated",
      fieldName: "updatedAt",
      fieldName2: "updatedBy",
      kmUdField: true,
      numeric: false,
      disablePadding: false,
      sortable: true,
      searchable: true,
      label: "Kiedy i kto zmodyfikował",
    },
    {
      id: "published",
      fieldName: "publishedAt",
      fieldName2: "publishedBy",
      kmUdField: true,
      numeric: false,
      disablePadding: false,
      sortable: true,
      searchable: true,
      label: "Kiedy i kto opublikował",
    },
    {
      id: "archived",
      fieldName: "archivedAt",
      fieldName2: "archivedBy",
      kmUdField: true,
      numeric: false,
      disablePadding: false,
      sortable: true,
      searchable: true,
      label: "Kiedy i kto zarchiwizował",
    },
    {
      id: "btns",
      kmUdField: false,
      numeric: false,
      disablePadding: false,
      searchable: false,
      sortable: false,
      component: RowButtons,
    },
  ];

  return (
    <Page className={classes.root} title="Aktualności - archiwalne">
      <Container maxWidth={false}>
        <KmFilteredTable markable={false} headCells={headCells} rows={rows} />
      </Container>
    </Page>
  );
};

const mapDispatchToProps = (dispatch) => ({
  setLogoutUser: () => dispatch(actions.setLogoutUser()),
  enableGlobalLoader: () => dispatch(actions.enableGlobalLoader()),
  disableGlobalLoader: () => dispatch(actions.disableGlobalLoader()),
});

export default connect(null, mapDispatchToProps)(ArchivedView);
